import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad76de90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ee-signup" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "row",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "no-role-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation big-icon" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "You currently have no role in relation to Trust Compliance", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " You don't currently hold a role. You have the option to either register as an External Examiner by clicking the 'Sign up' button or return to 'my account'. ", -1))
const _hoisted_9 = { class: "buttons" }
const _hoisted_10 = {
  key: 1,
  class: "signup-box"
}
const _hoisted_11 = { class: "ls-form" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Sign Up to be an External Examiner", -1))
const _hoisted_13 = { class: "input-box" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "LawID", -1))
const _hoisted_15 = { class: "text-field" }
const _hoisted_16 = { class: "input-box" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Title", -1))
const _hoisted_18 = { class: "text-field" }
const _hoisted_19 = { style: {"display":"flex","flex-flow":"row nowrap","justify-content":"space-between"} }
const _hoisted_20 = {
  class: "mr-1",
  style: {"width":"50%"}
}
const _hoisted_21 = { class: "input-box" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "First name", -1))
const _hoisted_23 = { class: "text-field" }
const _hoisted_24 = {
  class: "ml-1",
  style: {"width":"50%"}
}
const _hoisted_25 = { class: "input-box" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Last name", -1))
const _hoisted_27 = { class: "text-field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Firm name", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode(" Required field. ")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Address", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode(" Required field. ")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Telephone number", -1))
const _hoisted_33 = { style: {"display":"flex","justify-content":"space-between","width":"100%","align-items":"center"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-field2" }, "+61", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode(" Required field. ")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Membership types", -1))
const _hoisted_37 = { class: "dropdown-menu-wrap" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: "",
  selected: ""
}, "-- Please select --", -1))
const _hoisted_39 = ["value"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode("Required field. ")
], -1))
const _hoisted_41 = { class: "mt-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-2" }, "Publish on Web", -1))
const _hoisted_43 = { class: "checkbox-button" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ])
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Proof of External Examiner Course Completion", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg ml-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode(" File required. ")
], -1))
const _hoisted_47 = { class: "file-list mb-2" }
const _hoisted_48 = { class: "file-name" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-pdf" }, null, -1))
const _hoisted_50 = ["onClick"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-info-circle",
    style: {"font-size":"20px","color":"var(--ls-slate)"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, "Please be aware that the supported file formats include .PDF, .DOC, .DOCX, .XLS, .XLSX, .RTF, .JPG and .PNG. You may upload up to five files")
], -1))
const _hoisted_53 = { style: {"display":"flex","justify-content":"end"} }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 2,
  class: "row",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_57 = { class: "col-md-6" }
const _hoisted_58 = { class: "waitinforapproval-box" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-user-clock big-icon" }, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Waiting for Approval", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " You application has been submitted and is awaiting approval. ", -1))
const _hoisted_62 = { class: "buttons" }

export function render(_ctx, _cache) {
  const _component_PostcodeSearch = _resolveComponent("PostcodeSearch")
  const _component_FileDragAndDrop = _resolveComponent("FileDragAndDrop")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.waitingApproval && !_ctx.iWantToSignUp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "btn btn-outline mr-1",
                    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.signOut()), ["prevent"]))
                  }, "My Account"),
                  _createElementVNode("button", {
                    class: "btn btn-primary ml-1",
                    onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.iWantToSignUp = true), ["prevent"]))
                  }, "Sign up")
                ])
              ])
            ])
          ]))
        : (_ctx.iWantToSignUp)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("form", _hoisted_11, [
                _createElementVNode("fieldset", null, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.userAccount.user?.lawId ?? ''), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.userAccount.user?.title ?? ''), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.userAccount.user?.firstName ?? ''), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.userAccount.user?.lastName ?? ''), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-box", ((!_ctx.firmName || _ctx.firmName === '') && (_ctx.dirtyFields[0] || _ctx.submitPressed)) ? 'error': ''])
                    }, [
                      _hoisted_28,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.firmName) = $event)),
                        onChange: _cache[3] || (_cache[3] = $event => (_ctx.dirtyFields[0] = true)),
                        placeholder: "Enter firm name",
                        maxlength: "255"
                      }, null, 544), [
                        [_vModelText, _ctx.firmName]
                      ]),
                      _hoisted_29
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-box", ((!_ctx.address || _ctx.address === '') && (_ctx.dirtyFields[1] || _ctx.submitPressed)) ? 'error': ''])
                    }, [
                      _hoisted_30,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.address) = $event)),
                        onChange: _cache[5] || (_cache[5] = $event => (_ctx.dirtyFields[1] = true)),
                        placeholder: "Enter address",
                        maxlength: "255"
                      }, null, 544), [
                        [_vModelText, _ctx.address]
                      ]),
                      _hoisted_31
                    ], 2),
                    _createVNode(_component_PostcodeSearch, {
                      suburbStatePostcode: _ctx.suburbStatePostcode,
                      "onUpdate:suburbStatePostcode": _cache[6] || (_cache[6] = $event => ((_ctx.suburbStatePostcode) = $event)),
                      suburbError: _ctx.suburbError,
                      "onUpdate:suburbError": _cache[7] || (_cache[7] = $event => ((_ctx.suburbError) = $event)),
                      onUpdateSuburb: _ctx.updateSuburb
                    }, null, 8, ["suburbStatePostcode", "suburbError", "onUpdateSuburb"]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-box", ((!_ctx.phoneNumber || _ctx.phoneNumber === '') && (_ctx.dirtyFields[3] || _ctx.submitPressed)) ? 'error': ''])
                    }, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "15",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.phoneNumber) = $event)),
                          onChange: _cache[9] || (_cache[9] = $event => (_ctx.dirtyFields[3] = true)),
                          placeholder: ""
                        }, null, 544), [
                          [_vModelText, _ctx.phoneNumber]
                        ])
                      ]),
                      _hoisted_35
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["dropdown-menu", (!_ctx.selectedMembershipType && (_ctx.dirtyFields[4] || _ctx.submitPressed)) ? 'error': ''])
                    }, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.selectedMembershipType) = $event)),
                          onChange: _cache[11] || (_cache[11] = $event => (_ctx.dirtyFields[4] = true))
                        }, [
                          _hoisted_38,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membershipStatusTypes, (membershipT) => {
                            return (_openBlock(), _createElementBlock("option", { value: membershipT }, _toDisplayString(membershipT.name), 9, _hoisted_39))
                          }), 256))
                        ], 544), [
                          [_vModelSelect, _ctx.selectedMembershipType]
                        ])
                      ]),
                      _hoisted_40
                    ], 2),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("label", _hoisted_43, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.publishOnWeb) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.publishOnWeb]
                        ]),
                        _hoisted_44
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["file-upload mt-4", (_ctx.uploadedFileList?.length == 0 && (_ctx.dirtyFields[5] || _ctx.submitPressed)) ? 'error': ''])
                      }, [
                        _hoisted_45,
                        _createVNode(_component_FileDragAndDrop, {
                          disabled: _ctx.uploadedFileList.length == 5,
                          uploading: _ctx.uploading,
                          ref: "fileDropAndDrop",
                          onFileInputChanged: _cache[13] || (_cache[13] = $event => {_ctx.fileListChanged($event); _ctx.dirtyFields[5] = true}),
                          numFileLimit: 5,
                          fileSizeLimit: 50
                        }, null, 8, ["disabled", "uploading"]),
                        _hoisted_46,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedFileList, (f) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _hoisted_49,
                              _createTextVNode(" " + _toDisplayString(f.fileName), 1)
                            ]),
                            _createElementVNode("button", {
                              class: "btn btn-outline sml",
                              onClick: _withModifiers($event => (_ctx.deleteFile(f.id)), ["prevent"])
                            }, "Delete", 8, _hoisted_50)
                          ]))
                        }), 256))
                      ], 2)
                    ]),
                    _hoisted_51,
                    _hoisted_52
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                (_ctx.submitting)
                  ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                      key: 0,
                      class: "loading-indicator",
                      showLoadingText: false
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn btn-outline mr-1",
                  disabled: _ctx.submitting,
                  onClick: _cache[14] || (_cache[14] = _withModifiers($event => (_ctx.iWantToSignUp = false), ["prevent"]))
                }, "Cancel", 8, _hoisted_54),
                _createElementVNode("button", {
                  class: "btn btn-primary ml-1",
                  disabled: _ctx.submitting,
                  onClick: _cache[15] || (_cache[15] = _withModifiers($event => (_ctx.signUpForEE()), ["prevent"]))
                }, "Sign up", 8, _hoisted_55)
              ])
            ]))
          : (_ctx.waitingApproval)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _hoisted_60,
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("button", {
                        class: "btn btn-outline",
                        onClick: _cache[16] || (_cache[16] = _withModifiers($event => (_ctx.signOut()), ["prevent"]))
                      }, "My Account")
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmDialogue",
      modalOpened: true
    }, null, 512)
  ]))
}